import { render, staticRenderFns } from "./form-attachments.vue?vue&type=template&id=2fef87a9&scoped=true"
import script from "./form-attachments.vue?vue&type=script&lang=js"
export * from "./form-attachments.vue?vue&type=script&lang=js"
import style0 from "./form-attachments.vue?vue&type=style&index=0&id=2fef87a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef87a9",
  null
  
)

export default component.exports